export default "__VITE_ASSET__Cj5EHDBu__"